import * as React from 'react';

interface DriverJobsSiteDepartureProps {
    isAssistJob: boolean;
    isManualJob: boolean;
    cancel(): void;
    skipJob(): void;
    partCompleteJob(): void;
    completeJob(): void;
}

interface DriverJobsSiteDeparture {
    errors: any;
}

export default class DriverJobsSiteDepartureData extends React.Component<DriverJobsSiteDepartureProps, DriverJobsSiteDeparture> {
    constructor(props: DriverJobsSiteDepartureProps) {
        super(props);

        this.state = {
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    cancel = (e: any) => {
        e.preventDefault();
        this.props.cancel();
    }

    cantDoJob = (e: any) => {
        e.preventDefault();

        this.props.skipJob();
    }

    partCompleteJob = (e: any) => {
        e.preventDefault();

        this.props.partCompleteJob();
    }

    completeJob = (e: any) => {
        e.preventDefault();

        this.props.completeJob();
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {

        return (
            <div>
                <div className="mobileFont marginTop10 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h2 className="mobile-margin">Depart Site</h2>
                        <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.cancel(e)}></i>
                    </div>

                    <button className={this.props.isAssistJob || this.props.isManualJob ? "hidden" : "mobile-button--fill"} type="button" onClick={(e) => this.cantDoJob(e)}>Can't Do Job</button>
                    <div className={this.props.isAssistJob || this.props.isManualJob ? "hidden" : "mobile-note-size marginLeft20 marginRight10"}>Select "Can't Do Job" ONLY if there is nothing left on site.</div>
                    <div className={this.props.isAssistJob || this.props.isManualJob ? "hidden" : "mobile-note-size marginLeft20 marginRight10"}>If you have left Void Gear on site but not installed it, you can also click this button.</div>
                    <button className={this.props.isAssistJob || this.props.isManualJob ? "hidden" : "mobile-button--fill"} type="button" onClick={(e) => this.partCompleteJob(e)}>Part Complete</button>
                    <div className={this.props.isAssistJob || this.props.isManualJob ? "hidden" : "mobile-note-size marginLeft20 marginRight10"}>Select "Part Complete" ONLY if you have done some of the job and we need to return tomorrow. This should be discussed with your supervisor prior to choosing this option.</div>
                    <button className="mobile-button--fill" type="button" onClick={(e) => this.completeJob(e)}>Complete</button>
                    <div className="mobile-note-size marginLeft20 marginRight10">Select "Complete" ONLY if you have completed everything on site and we do not need to return.</div>
                </div>
            </div>
        );

    }
}
